import { get } from 'svelte/store';
import { preload } from '$lib/components/_i18n';
import { app } from '$lib/stores/app/store';
import { activeLocale } from './l10n';
import { resolveDisplayLocale } from './resolve-display-locale';
import type { Locale } from './locale';

/**
 * Writes the resolved display locale and preloads shared chrome copy.
 * Root `+layout.js` calls this so unlocalized routes still localize nav,
 * footer, 404, and form-validation strings.
 * @returns {Promise<Locale>} Active display locale.
 */
export async function activateDisplayLocale(): Promise<Locale> {
	const locale = resolveDisplayLocale();
	activeLocale.set(locale);
	await preload(locale, get(app).meta.viewerCountry);
	return locale;
}
